import store from '../store';
/* eslint-disable */
export default async function decreaseTemplateQuestionsCounter(template, type) {
    let length = template.value.questionsCount;
    let count = template.value.questions[type].counter;

    if (length > 0 && count > 0) {
        template.value.questions[type].counter -= 1;
        template.value.questionsCount -= 1;
    }

    if( template.value.questionsCount > 0){
        await store.dispatch('setDataFlag', true);
        await store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');

    }else{
        await store.dispatch('setDataFlag', false);
    }
}
